import { createAction, props } from '@ngrx/store';
import { IPurchaseActivityItem, IPurchaseActivityResponse } from '../purchase-activity.models';

export const PREVIOUS_ORDERS_LOAD_ORDERS = '[Purchase Activity] Previous Orders - Load Orders';
export const PREVIOUS_ORDERS_LOAD_ORDERS_SUCCESS = '[Purchase Activity] Previous Orders - Load Orders SUCCESS';
export const PREVIOUS_ORDERS_LOAD_ORDERS_FAILURE = '[Purchase Activity] Previous Orders - Load Orders FAILURE';
export const PREVIOUS_ORDERS_LOAD_ARCHIVE = '[Purchase Activity] Previous Orders - Load Archive';
export const PREVIOUS_ORDERS_LOAD_ARCHIVE_SUCCESS = '[Purchase Activity] Previous Orders - Load Archive SUCCESS';
export const PREVIOUS_ORDERS_LOAD_ARCHIVE_FAILURE = '[Purchase Activity] Previous Orders - Load Archive FAILURE';
export const PENDING_ORDERS_LOAD_ORDERS = '[Purchase Activity] Pending Orders - Load Orders';
export const PENDING_ORDERS_LOAD_ORDERS_SUCCESS = '[Purchase Activity] Pending Orders - Load Orders SUCCESS';
export const PENDING_ORDERS_LOAD_ORDERS_FAILURE = '[Purchase Activity] Pending Orders - Load Orders FAILURE';
export const PREVIOUS_QUOTES_LOAD = '[Purchase Activity] Previous Quotes - Load';
export const PREVIOUS_QUOTES_LOAD_SUCCESS = '[Purchase Activity] Previous Quotes - Load SUCCESS';
export const PREVIOUS_QUOTES_LOAD_FAILURE = '[Purchase Activity] Previous Quotes - Load FAILURE';
export const PREVIOUS_REQUESTS_LOAD = '[Purchase Activity] Previous Requests - Load';
export const PREVIOUS_REQUESTS_LOAD_SUCCESS = '[Purchase Activity] Previous Requests - Load SUCCESS';
export const PREVIOUS_REQUESTS_LOAD_FAILURE = '[Purchase Activity] Previous Requests - Load FAILURE';
export const UPDATE_PREVIOUS_REQUEST_VERSION_STATUS: string = '[Purchase Activity] Update Previous Request Version Status';
export const DELETE_ITEM_FROM_PENDING_ORDER = '[Purchase Activity] Delete Item From Pending Order - Load';
export const DELETE_ITEM_FROM_PENDING_ORDER_SUCCESS = '[Purchase Activity] Delete Item From Pending Order - Load SUCCESS';
export const DELETE_ITEM_FROM_PENDING_ORDER_FAILURE = '[Purchase Activity] Delete Item From Pending Order - Load FAILURE';
export const CHANGE_PAGINATION = '[Purchase Activity] Change Pagination';
export const SET_IS_LOADED_FOR_TAB = '[Purchase Activity] Set Is Loaded For Tab';
export const SET_IS_LOADED_FOR_ITEM = '[Purchase Activity] Set Is Loaded For Item';
export const CLEAR_PURCHASE_ACTIVITY_SECTION = '[Purchase Activity] Clear Purchase Activity Section';
export const LOAD_SPECIFIC_PURCHASE_ACTIVITY_ITEM_IN_SECTION = '[Purchase Activity] Load Specific Purchase Activity Item In Section';
export const LOAD_SPECIFIC_PURCHASE_ACTIVITY_ITEM_IN_SECTION_SUCCESS = '[Purchase Activity] Load Specific Purchase Activity Item In Section SUCCESS';
export const LOAD_SPECIFIC_PURCHASE_ACTIVITY_ITEM_IN_SECTION_FAILURE = '[Purchase Activity] Load Specific Purchase Activity Item In Section FAILURE';
export const DETAILS_PAGE_SET: string = '[Purchase Activity] Details Page - Set';
export const DETAILS_PAGE_LOAD: string = '[Purchase Activity] Details Page - Load';
export const DETAILS_PAGE_LOAD_SUCCESS: string = '[Purchase Activity] Details Page - Load SUCCESS';
export const DETAILS_PAGE_LOAD_FAILURE: string = '[Purchase Activity] Details Page - Load FAILURE';

// *** Previous Orders - Orders nonSAP store ***
export const loadOrdersInPreviousOrders = createAction(
  PREVIOUS_ORDERS_LOAD_ORDERS,
  (page: number | undefined = undefined) => ({page}),
);
export const loadOrdersInPreviousOrdersSuccess = createAction(
  PREVIOUS_ORDERS_LOAD_ORDERS_SUCCESS,
  props<{orders: IPurchaseActivityResponse}>(),
);
export const loadOrdersInPreviousOrdersFailure = createAction(
  PREVIOUS_ORDERS_LOAD_ORDERS_FAILURE,
  props<{resError: string}>(),
);

// *** Purchase Activity Details Page ***
export const setPurchaseActivityDetails = createAction(
  DETAILS_PAGE_SET,
  (purchaseActivityDetails: IPurchaseActivityItem) => ({purchaseActivityDetails}),
);
export const loadPurchaseActivityDetails = createAction(
  DETAILS_PAGE_LOAD,
  (id: string, endpointType: string) => ({id, endpointType}),
);
export const loadPurchaseActivityDetailsSuccess = createAction(
  DETAILS_PAGE_LOAD_SUCCESS,
  props<{purchaseActivityDetails: IPurchaseActivityResponse}>(),
);
export const loadPurchaseActivityDetailsFailure = createAction(
  DETAILS_PAGE_LOAD_FAILURE,
  props<{resError: string}>(),
);

// *** Hybris Orders - Archive ***
export const loadArchiveInPreviousOrders = createAction(
  PREVIOUS_ORDERS_LOAD_ARCHIVE,
  (page: number | undefined = undefined) => ({page}),
);
export const loadArchiveInPreviousOrdersSuccess = createAction(
  PREVIOUS_ORDERS_LOAD_ARCHIVE_SUCCESS,
  props<{archiveOrders: IPurchaseActivityResponse}>(),
);
export const loadArchiveInPreviousOrdersFailure = createAction(
  PREVIOUS_ORDERS_LOAD_ARCHIVE_FAILURE,
  props<{resError: string}>(),
);

// *** Pending Orders ***
export const loadOrdersInPendingOrders = createAction(
  PENDING_ORDERS_LOAD_ORDERS,
  (page: number | undefined = undefined) => ({page}),
);
export const loadOrdersInPendingOrdersSuccess = createAction(
  PENDING_ORDERS_LOAD_ORDERS_SUCCESS,
  props<{pendingOrders: IPurchaseActivityResponse}>(),
);
export const loadOrdersInPendingOrdersFailure = createAction(
  PENDING_ORDERS_LOAD_ORDERS_FAILURE,
  props<{resError: string}>(),
);

// *** Previous Quotes ***
export const loadQuotesInPreviousQuotes = createAction(
  PREVIOUS_QUOTES_LOAD,
  (page: number | undefined = undefined) => ({page}),
);
export const loadQuotesInPreviousQuotesSuccess = createAction(
  PREVIOUS_QUOTES_LOAD_SUCCESS,
  props<{previousQuotes: IPurchaseActivityResponse}>(),
);
export const loadQuotesInPreviousQuotesFailure = createAction(
  PREVIOUS_QUOTES_LOAD_FAILURE,
  props<{resError: string}>(),
);

// *** Previous Requests ***
export const loadRequestsInPreviousRequests = createAction(
  PREVIOUS_REQUESTS_LOAD,
  (page: number | undefined = undefined) => ({page}),
);
export const loadRequestsInPreviousRequestsSuccess = createAction(
  PREVIOUS_REQUESTS_LOAD_SUCCESS,
  props<{previousRequests: IPurchaseActivityResponse}>(),
);
export const loadRequestsInPreviousRequestsFailure = createAction(
  PREVIOUS_REQUESTS_LOAD_FAILURE,
  props<{resError: string}>(),
);
export const updatePreviousRequestVersionStatus = createAction(
  UPDATE_PREVIOUS_REQUEST_VERSION_STATUS,
  props<{tab: string, page: number, orderId: string, newStatus: string}>(),
);

// *** Delete Item From Pending Order ***
export const deleteItemFromPendingOrder = createAction(
  DELETE_ITEM_FROM_PENDING_ORDER,
  props<{orderId: string, orderItemId: string}>(),
);
export const deleteItemFromPendingOrderSuccess = createAction(
  DELETE_ITEM_FROM_PENDING_ORDER_SUCCESS,
  props<{orderId: string}>(),
);
export const deleteItemFromPendingOrderFailure = createAction(
  DELETE_ITEM_FROM_PENDING_ORDER_FAILURE,
  props<{resError: string}>(),
);

export const clearPurchaseActivitySection = createAction(
  CLEAR_PURCHASE_ACTIVITY_SECTION,
  props<{tab: string}>(),
);

// *** Load Specific Purchase Activity item in section ***
export const loadSpecificPurchaseActivityItemInSection = createAction(
  LOAD_SPECIFIC_PURCHASE_ACTIVITY_ITEM_IN_SECTION,
  props<{tab: string, page: number, itemId: string}>(),
);

export const loadSpecificPurchaseActivityItemInSectionSuccess = createAction(
  LOAD_SPECIFIC_PURCHASE_ACTIVITY_ITEM_IN_SECTION_SUCCESS,
  props<{tab: string, response: IPurchaseActivityResponse, page: number}>(),
);

export const loadSpecificPurchaseActivityItemInSectionFailure = createAction(
  LOAD_SPECIFIC_PURCHASE_ACTIVITY_ITEM_IN_SECTION_FAILURE,
  props<{resError: string}>(),
);

// *** Change pagination ***
export const changePagination = createAction(
  CHANGE_PAGINATION,
  props<{tab: string, page: number}>(),
);

export const setIsLoadedForTab = createAction(
  SET_IS_LOADED_FOR_TAB,
  props<{tab: string, isLoaded: boolean}>(),
);

export const setIsLoadedForItem = createAction(
  SET_IS_LOADED_FOR_ITEM,
  props<{tab: string, page: number, orderId: string, isLoaded: boolean}>(),
);
